/* Per-tab public team browsing context. Cart data is never read or modified here. */
(function () {
  'use strict';
  if (window.gfShoppingContextLoaded) return;
  window.gfShoppingContextLoaded = true;
  var doc = document;
  var key = 'gf:team-shopping-url:v1';
  var remembered = null;
  var started = false;
  var validation = 0;
  var fallbacks = new WeakMap();
  var fallbackLabels = new WeakMap();

  function safeURL(raw) {
    if (typeof raw !== 'string' || raw.length > 4096 || !/^\/(?!\/)/.test(raw) || /[\\\s#]/.test(raw)) return null;
    // Reject encoded path separators, dot segments and normalization tricks before parsing.
    var path = raw.split('?')[0];
    if (/%|\/\.|\/\//.test(path)) return null;
    var url;
    try { url = new URL(raw, window.location.origin); } catch (_) { return null; }
    if (url.origin !== window.location.origin || url.pathname !== path) return null;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages\/[a-z0-9-]+|products\/[a-z0-9-]+|collections\/(?!all(?:\/|$))[a-z0-9-]+(?:\/products\/[a-z0-9-]+|\/[a-z0-9-]+(?:\+[a-z0-9-]+)*)?)$/.test(path)) return null;
    var clean = new URLSearchParams();
    var product = /\/products\//.test(path);
    var collection = /\/collections\//.test(path) && !product;
    url.searchParams.forEach(function (value, name) {
      if (product && name === 'variant' && /^\d+$/.test(value)) clean.set(name, value);
      if (collection && ((name === 'page' && /^[1-9]\d*$/.test(value)) || (name === 'sort_by' && /^[a-z_-]+$/.test(value)) || /^filter\.(?:p|v)\.[a-zA-Z0-9_.-]+$/.test(name))) clean.append(name, value);
    });
    return path + (clean.toString() ? '?' + clean.toString() : '');
  }

  function matchesContext(doc, url) {
    var marker = doc.querySelector('[data-gf-shopping-context]');
    if (!marker || !url) return false;
    var path = url.split('?')[0];
    return safeURL(marker.getAttribute('data-path')) === path &&
      ['page', 'collection', 'product'].indexOf(marker.getAttribute('data-kind')) !== -1;
  }

  function matchesCurrentCollection(url) {
    var marker = doc.querySelector('[data-gf-shopping-context]');
    if (!marker || marker.getAttribute('data-kind') !== 'collection' || !url) return false;
    var markerPath = safeURL(marker.getAttribute('data-path'));
    // Filter Pills swaps grid/chips and pushes history without replacing this marker.
    // Trust only tag/filter changes within the already verified collection on this page;
    // remote return validation continues requiring an exact current server marker.
    var collectionRoute = /^(\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9-]+)(?:\/[a-z0-9-]+(?:\+[a-z0-9-]+)*)?$/;
    var original = markerPath && markerPath.match(collectionRoute);
    var current = url.split('?')[0].match(collectionRoute);
    return !!(original && current && original[1] === current[1]);
  }

  function capture() {
    var url = safeURL(window.location.pathname + window.location.search);
    if (!matchesContext(doc, url) && !matchesCurrentCollection(url)) return;
    validation += 1;
    remembered = url;
    try { window.sessionStorage.setItem(key, url); } catch (_) { /* Storage may be disabled. */ }
  }

  function apply() {
    doc.querySelectorAll('[data-gf-shopping-return]').forEach(function (link) {
      if (!fallbacks.has(link)) fallbacks.set(link, link.getAttribute('href'));
      var target = remembered || fallbacks.get(link);
      if (target && link.getAttribute('href') !== target) link.setAttribute('href', target);
      var returnLabel = link.getAttribute('data-gf-shopping-return-label');
      if (returnLabel) {
        if (!fallbackLabels.has(link)) fallbackLabels.set(link, link.textContent);
        var label = remembered ? returnLabel : fallbackLabels.get(link);
        if (link.textContent !== label) link.textContent = label;
      }
    });
  }

  function restore() {
    var request = ++validation;
    remembered = null;
    apply();
    var saved;
    try { saved = safeURL(window.sessionStorage.getItem(key)); } catch (_) { /* Keep Liquid fallback. */ }
    if (!saved) return;
    // Revalidate resource identity: deleted, redirected, locked and unrelated pages
    // must not become return destinations just because storage contains their URL.
    fetch(saved, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) { return response.ok && !response.redirected ? response.text() : ''; })
      .then(function (html) {
        if (request !== validation) return;
        // Another restored page may have changed this tab's context during the GET.
        try { if (safeURL(window.sessionStorage.getItem(key)) !== saved) return; } catch (_) { return; }
        if (matchesContext(new DOMParser().parseFromString(html, 'text/html'), saved)) {
          remembered = saved;
          apply();
        }
      }).catch(function () { /* Network failure leaves useful server fallback. */ });
  }

  function init() {
    if (started) return;
    started = true;
    capture();
    if (!remembered && doc.querySelector('[data-gf-shopping-return]')) restore();
    apply();
    new MutationObserver(apply).observe(doc.body, { childList: true, subtree: true });
  }

  // Variant selectors update history during their change handlers; capture afterwards.
  doc.addEventListener('change', function () { window.setTimeout(capture, 0); });
  doc.addEventListener('click', function () { window.setTimeout(capture, 0); });
  window.addEventListener('pagehide', function () { validation += 1; capture(); });
  window.addEventListener('popstate', capture);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && doc.querySelector('[data-gf-shopping-return]')) restore();
    else { capture(); apply(); }
  });
  doc.addEventListener('shopify:section:load', function () { capture(); apply(); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
